'use client';

import { RadioGroup } from '@get-mosh/msh-shared';
import classNames from 'classnames';
import Image from 'next/image';
import { ChangeEvent, useState } from 'react';
import styles from './advanced-radio-group.module.scss';
import { EventProps } from 'src/analytics/EventProps';
import { trackLandingPageButtonClick } from 'src/analytics/Events';

type AdvancedRadioGroupSectionProps = {
    options: Array<{
        label: string;
        value: string;
        image: string;
        content: Array<string>;
    }>;
    eventProps?: EventProps;
};

const AdvancedRadioGroup = ({
    options,
    eventProps,
}: AdvancedRadioGroupSectionProps) => {
    const [value, setValue] = useState(options[0].value);
    const onChange = (event: ChangeEvent<HTMLInputElement>) => {
        trackLandingPageButtonClick({
            label: event.target.title,
            ...eventProps,
        });
    };

    return (
        <div className={styles['advanced-radio-group']}>
            <div className={styles['advanced-radio-group--image-container']}>
                {options.map((o) => (
                    <Image
                        key={o.value}
                        className={classNames(
                            styles['advanced-radio-group--image'],
                            {
                                [styles['advanced-radio-group--image-active']]:
                                    o.value === value,
                            },
                        )}
                        src={o.image}
                        alt={o.label}
                        fill
                        sizes="50vw"
                    />
                ))}
            </div>
            <div className={styles['advanced-radio-group--card']}>
                <div className={styles['advanced-radio-group--content']}>
                    {options.map((o) => (
                        <div
                            key={o.value}
                            className={classNames(
                                styles['advanced-radio-group--content-item'],

                                {
                                    [styles[
                                        'advanced-radio-group--content-item--active'
                                    ]]: o.value === value,
                                },
                            )}
                        >
                            <h4>{o.label}</h4>
                            <ul>
                                {o.content.map((c, i) => (
                                    <li key={i}>{c}</li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
                <div className={styles['advanced-radio-group--divider']} />
                <RadioGroup
                    name="radio-group"
                    options={options.map((o) => ({
                        title: o.label,
                        value: o.value,
                        image: o.image,
                        label: o.label,
                    }))}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => {
                        setValue(e.target.value);
                        if (onChange) {
                            onChange(e);
                        }
                    }}
                />
            </div>
        </div>
    );
};

export default AdvancedRadioGroup;
